import { getShouldUseZendeskSandbox } from "../serialized-data/getShouldUseZendeskSandbox";

export const BRANDS_CATEGORY_ID = getShouldUseZendeskSandbox()
  ? 14636971293595
  : 360000490012;
